import React from 'react';
import {
    Tabs,
    TabsItem,
    Div,
    FormItem,
    ButtonGroup,
    Progress
} from '@vkontakte/vkui';

import {Button, FormLayout, FormLayoutGroup, Input} from '@vkontakte/vkui';
import SendHelpForm from "../api/SendHelpForm";
import axios from "axios";

import ChangePassForm from "../api/ChangePassForm";


class Login extends React.Component {

    state = {
        currentTab: 'login',
        isLoading: false,
        username: '',
        password: '',
        progress: 0
    }

    constructor(props) {
        super(props);

    }

    doLogin = (username = null, password = null,  is_application = null, application_version = null) => {
        this.setState({isLoading: true})
        if (this.interval) {
            clearInterval(this.interval)
            this.setState({progress: 0})
        }

        this.interval = setInterval(() => {
            this.setState({progress: this.state.progress + 5})
        }, 500)
        const body = new FormData()
        body.append('username', username ?? this.state.username.trim().replace(' ', ''))
        body.append('password', password ?? this.state.password)
        if( is_application) {
            body.append('is_application', is_application)
        }
        if( application_version) {
            body.append('application_version', application_version)
        }
        axios.post(this.props.base_url + '?app=login&is_react=', body,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data',

                }

            }
        ).then((response) => {
            this.setState({isLoading: false})
            if (this.interval) {
                clearInterval(this.interval)
            }

            if (response.data.error === undefined) {
                window.postMessage({type: 'loginEvent'})
            } else {

                window.postMessage({type: 'loginEvent', error: response.data.error})
            }
        }).catch(e => {
            this.setState({isLoading: false})
            if (this.interval) {
                clearInterval(this.interval)
            }

            // window.postMessage({type: 'loginEvent', error: e.toString()})
        })
    }

    changeLogin = (event) => {

        let value = event.target.value
        value = value.toString().trim().replace(' ', '')
        this.setState({username: value})
        this.props.onChange({username: value})
    }

    changePass = (event) => {

        this.setState({password: event.target.value})
        this.props.onChange({password: event.target.value})
    }

    handleClick = () => {
        this.doLogin()
    }

    componentDidMount() {
        window.addEventListener("message", this.receiveMessage, false)
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval)
        }
        window.removeEventListener("message", this.receiveMessage, false)
    }

    receiveMessage = (event) => {


        if (event.data.type == 'loginDataFromApp' && event.data.data && event.data.data.username && event.data.data.password) {
            if(this.state.isLoading) return
            const {username, password,  is_application, application_version} = event.data.data
            //window.postMessage({type: 'error', text: `u: ${username} p:${password}`})
            this.setState({username, password})
            this.doLogin(username, password,  is_application, application_version)
        }
    }


    render() {

        return (

            <div className="login-wrapper">
                <Div className="login-form">
                    <Tabs>
                        <TabsItem
                            selected={this.state.currentTab === 'login'}
                            onClick={() => this.setState({currentTab: 'login'})}
                        >Авторизация</TabsItem>
                        <TabsItem
                            selected={this.state.currentTab === 'help'}
                            onClick={() => this.setState({currentTab: 'help'})}
                        >Help</TabsItem>
                    </Tabs>
                    {this.state.currentTab === 'login'
                        && <FormLayout>
                            <FormLayoutGroup title="Введите логин и пароль">
                                <FormItem top="Имя пользователя">
                                    <Input type="text" placeholder="Логин" size="l" onChange={this.changeLogin}/>
                                </FormItem>
                                <FormItem top="Пароль">
                                    <Input type="password" placeholder="Пароль" onChange={this.changePass}/>
                                </FormItem>
                                <FormItem>
                                    <ButtonGroup stretched>
                                        <Button onClick={this.handleClick} size="l"
                                                loading={this.state.isLoading}>Вход</Button>

                                        <Button onClick={() => this.setState({currentTab:'resetPass'})} size="l" mode='link' style={{textDecoration: 'underline'}}
                                                 >Сменить пароль</Button>
                                    </ButtonGroup>
                                </FormItem>
                                {this.state.isLoading &&
                                    <FormItem id="progresslabel" top="Вход в систему. Пожалуйста подождите...">
                                        <Progress aria-labelledby="progresslabel" value={this.state.progress}/>
                                    </FormItem>}
                            </FormLayoutGroup>
                        </FormLayout>}

                    {this.state.currentTab === 'help' &&
                        <SendHelpForm goBack={() => this.setState({currentTab: 'login'})}
                                      base_url={this.props.base_url}/>}

                    {this.state.currentTab === 'resetPass' &&
                        <ChangePassForm goBack={() => this.setState({currentTab: 'login'})}
                                      base_url={this.props.base_url}/>}
                </Div>
            </div>
        );

    }


}

export default Login;
